import React, { Component } from 'react';



class Team extends Component {

    state = {
        timer: 0,
        team: [{
            name: "Victor Hugo",
            text: "",
            img: "https://graph.facebook.com/xxx/picture?type=large"
        },
        {
            name: "Heberth Feres",
            text: "",
            img: "https://graph.facebook.com/xxx/picture?type=large"
        }]
    }

    componentWillReceiveProps() {
        this.rand();
    }

    componentDidMount() {
        this.rand();
        this.setState({
            timer: window.setInterval(this.rand.bind(this), 60000)
        });
    }

    componentWillUnmount() {
        window.clearInterval(this.state.timer);
    }

    rand() {
        var list = this.state.team.slice();
        for (var i = 0; i < list.length; i++) {
            var pos = Math.floor(Math.random() * list.length);
            var temp = list[pos];
            list[pos] = list[i];
            list[i] = temp;
        }
        this.setState({
            team: list
        });
    }

    render() {
        return (
            <ul className="lista team-list">
                {this.state.team.map(function (item, index) {
                    return (
                        <li key={index}>
                            <div
                                className="team-icon"
                                style={{
                                    backgroundImage: "url(" + item.img + ")"
                                }}>

                            </div>
                            <div className="team-item-name">
                                {item.name}
                            </div>
                            <div className="team-item-text">

                            </div>
                        </li>
                    );

                })}

            </ul>

        );
    }
}

export default Team;
